import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout, ConversationRoutes } from 'entities/ExportRouters'

export const MembersAccessLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.members}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          path: ConversationRoutes.root,
        })
      }}
    />
  )
})
